import React, { FC } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { ROUTE_ALIASES } from '../constants';
import {
  getCurrentPath,
  getUrlByDynamicAlias,
  isDynamicAlias,
  isMatchPageAlias,
  isStaticAlias,
} from '../utils';
import { MatchRedirect } from './MatchRedirect';

export const RedirectToAliasesOrNotFound: FC = () => {
  const { location: { pathname } } = useHistory();
  const currentPath = getCurrentPath(pathname);

  if (isStaticAlias(currentPath, ROUTE_ALIASES)) {
    return (
      <Redirect to={`/${ROUTE_ALIASES[currentPath]}`} />
    );
  }

  if (isDynamicAlias(currentPath)) {
    return (
      <Redirect to={`/${getUrlByDynamicAlias(currentPath)}`} />
    );
  }

  if (isMatchPageAlias(currentPath)) {
    return (
      <MatchRedirect />
    );
  }

  return (
    <Redirect to="/404" />
  );
};
